import React from "react";
//react-toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Switch, Route } from "react-router-dom";
import ProtectedAuthRoute from "./routes/proctectedRoute";
import ExamMainPage from "./pages/examMain.page/ExamMain.page";
import CandidateExamPageIntro from "./pages/candidateExamIntro.page";
import Login from "./pages/Login/Login";
import CandidateAuthPage from "./pages/candidateAuth.page";
import FeedBackModal from "./components/FeedBackModal/FeedBackModal";
import ExamSectionPrivateRoute from "./privateRoutes/ExamSectionPrivateRoute";

const ProtectedAuthenticationPage = (props) => (
  <ProtectedAuthRoute {...props} component={ExamMainPage} />
);
const MainRouter = () => {
  return (
    <>
      <Switch>
        <ExamSectionPrivateRoute
          path="/exam/:examId"
          component={ProtectedAuthenticationPage}
        />
        <ProtectedAuthRoute path="/exam" component={CandidateExamPageIntro} />
        <Route path="/login" component={Login} />
        <ProtectedAuthRoute path="/" component={CandidateAuthPage} />

        {/* <Route path="*">
            <NoMatch />
          </Route> */}
      </Switch>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        theme="colored"
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <FeedBackModal />
    </>
  );
};

export default MainRouter;
